import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldsCropsGridComponent } from './fields-crops-grid.component';
import { TabModule } from '../tab/tab.module';
import {
  DxButtonModule,
  DxColorBoxModule,
  DxDataGridModule,
  DxSwitchModule
} from 'devextreme-angular';
import { FieldDrawModule, FieldSvgModule, GridDefaultModule, GridTitleModule } from 'shared';
import { IconModule } from '@visurel/iconify-angular';



@NgModule({
  declarations: [FieldsCropsGridComponent],
  imports: [
    CommonModule,
    TabModule,
    DxDataGridModule,
    FieldSvgModule,
    FieldDrawModule,
    DxColorBoxModule,
    DxButtonModule,
    DxSwitchModule,
    IconModule,
    GridTitleModule,
    GridDefaultModule,
  ],
  exports: [FieldsCropsGridComponent]
})
export class FieldsCropsGridModule { }
